import { Box, styled } from '@mui/material';

export const AppWrapperStyled = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'hasMarginAndPadding' &&
    prop !== 'isUserSuccessfullyAuthenticated',
})(({ theme, hasMarginAndPadding, isUserSuccessfullyAuthenticated }) => {
  const getAuthStyles = () => {
    if (isUserSuccessfullyAuthenticated)
      return {
        marginLeft: hasMarginAndPadding && 70,
        paddingLeft: hasMarginAndPadding && '32px',
        paddingRight: hasMarginAndPadding && '32px',

        [theme.breakpoints.down('xxl')]: {
          paddingLeft: hasMarginAndPadding && '24px',
          paddingRight: hasMarginAndPadding && '24px',
        },
        [theme.breakpoints.down('xl')]: {
          paddingLeft: hasMarginAndPadding && '16px',
          paddingRight: hasMarginAndPadding && '16px',
        },
        [theme.breakpoints.down('lg')]: {
          marginLeft: 0,
          padding: 0,
        },
      };

    return {
      display: 'flex',
      flexDirection: 'column',
      margin: '0px auto',
    };
  };

  return {
    position: 'relative',
    width: 'auto',
    height: !isUserSuccessfullyAuthenticated && '100vh',
    ...getAuthStyles(),
  };
});
